import { createReducer } from 'redux-create-reducer'
import type { AccountPlan } from 'types/business2020'
import { PRICING_RESET, PRICING_UPDATE } from '@disco/constants/ActionTypes'
import type { PlanId } from '@disco/utils/featuresAccessLevel'
import {
  ARTIST_ID,
  ENTERPRISE_ID,
  PLUS_ID,
  PRO_ID,
} from '@disco/utils/featuresAccessLevel'
export type PricingFormState = {
  plan: AccountPlan | null | undefined
  componentsQuantity: {
    tracks: number | null | undefined
    users: number | null | undefined
    discoverySuite: number | null | undefined
    watermarking: (number | 'unlimited') | null | undefined
  }
  paymentPeriod: 'monthly' | 'annual'
  // only used on mobile
  openBillingSummary: boolean
  paymentDetailsSaved: boolean
  plansTabs: {
    active: number | null | undefined
    ids: PlanId[][]
  }
}
export const BUSINESS_PLANS_TAB = 0
export const ARTIST_PLANS_TAB = 1
export const BUSINESS_PLANS_LIST: PlanId[] = [ENTERPRISE_ID, PLUS_ID, PRO_ID]
export const ARTIST_PLANS_LIST: PlanId[] = [ARTIST_ID]
const initialState: PricingFormState = {
  plan: null,
  componentsQuantity: {
    tracks: null,
    users: null,
    discoverySuite: null,
    watermarking: null,
  },
  paymentPeriod: 'annual',
  openBillingSummary: false,
  paymentDetailsSaved: false,
  plansTabs: {
    active: null,
    ids: [BUSINESS_PLANS_LIST, ARTIST_PLANS_LIST],
  },
}
export const pricingFormReducer = createReducer<PricingFormState, any>(
  initialState,
  {
    [PRICING_RESET]() {
      return initialState
    },

    [PRICING_UPDATE](state, action) {
      return { ...state, ...action.fields }
    },
  },
)
